(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/display-choices.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/display-choices.js');
"use strict";

const {
  useContext
} = React;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  BetslipCouponType
} = svs.components.tipsen.engine.constants;
const DisplayChoices = () => {
  const {
    setIsBetslipVisible,
    isBetslipVisible,
    isAnySystemSelected,
    couponBetButtonCount,
    couponType
  } = useContext(BetslipContext);
  const isExternal = couponType === BetslipCouponType.ExternaSystemspel;
  return React.createElement("div", {
    className: "tipsen-betslip-tags"
  }, isBetslipVisible && React.createElement("div", {
    className: "tipsen-betslip-button tipsen-betslip-menu-flag"
  }, React.createElement("button", {
    "aria-hidden": !isBetslipVisible,
    className: "qa-betslip-menu-btn",
    onClick: () => {
      setIsBetslipVisible(false);
    },
    type: "button"
  }, "Meny")), (isAnySystemSelected || couponBetButtonCount > 0 || isExternal) && !isBetslipVisible && React.createElement("div", {
    className: "tipsen-betslip-button tipsen-betslip-betslip-flag"
  }, React.createElement("button", {
    "aria-hidden": isBetslipVisible,
    className: "qa-betslip-betslip-btn",
    onClick: () => {
      setIsBetslipVisible(true);
    },
    type: "button"
  }, "Betslip")));
};
setGlobal('svs.components.tipsen.betslip.views.parts.DisplayChoices', DisplayChoices);

 })(window);